/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useState, Fragment, useId, useEffect } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { extenstionType } from '../../../../../../CommonComponent/staticValues';
import { dataService } from '../../../../../../services/dataService';
import { registrationType } from '../../../../../../CommonComponent/staticValues';
import { useSelector } from 'react-redux';
import { buyerFees } from '../../../../../../CommonComponent/staticValues';
import { buyerFeeLabel, isBuyerFeeType } from '../../../../../../utils/buyerFeeUtils';
import { currencySymbolMapping } from '../../../../../../CommonComponent/staticValues';
import ToolTip from '../../../../../../CommonComponent/tooltip'
import { Tooltip } from 'react-tippy';
import { useLocation } from 'react-router-dom';
import disableFieldsBasedOnAuctionStatus from '../../../../disableFieldsBasedOnAuctionStatus';
import { useLDClient } from 'launchdarkly-react-client-sdk';

export default function SetUpAuctionRules({auctionData,setAuctionData, setEditedAuctionData, edit}) {
    const profile = useSelector((state) => state.profile);
    const pricing = useSelector((state) => state.pricingSlice);
    const state = useLocation();
    const [extensionTypeShow, setExtensionTypeShow] = useState(edit ? true : false)
    const [registrationTypeShow, setRegistrationTypeShow] = useState(edit ? true : false)
    const [showFullContent, setShowFullContent] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [errorMessages, setErrorMessages] = useState();
    const [isManual, setIsManual] = useState('');
    const [isCardValid, setIsCardValid] = useState('');
    const [registerWithCreditCardEnabled, setRegisterWithCreditCardEnabled] = useState('');
    const [lastEditedVoluntaryIndex, setLastEditedVoluntaryIndex] = useState(null);
    const recommendedFeeGroupName = useId();

    const plan_status = pricing.plan_type;
    const ldClient = useLDClient();

    /**
     * The function `handleBuyerFeeValueChange` is used to handle changes in the buyer fee value in a
     * React component, ensuring that the value is valid and updating the state accordingly.
     */
    const handleBuyerFeeValueChange = (e, field) => {
        e.preventDefault();
        const newValue = e.target.value;
        let digitsOnly = newValue.replace(/^0*(\d*)/, '$1').replace(/\D/g, '');
        if (field === 'percentage') {
            if (digitsOnly !== '' && !isNaN(digitsOnly)) {
                digitsOnly = parseFloat(digitsOnly);
                digitsOnly = Math.min(100, Math.max(0, digitsOnly));
            }
        }
        if (field === 'extension_time_between_lots') {
            const enteredValue = e.target.value.trim();
            const newValue = parseInt(enteredValue);
            if (!isNaN(newValue)) {
                // Check if the entered value is within the range 1 to 60
                if (newValue >= 1 && newValue <= 60) {
                    // If it is within the range, update the state with the new value
                    setAuctionData({
                        ...auctionData,
                        [field]: newValue
                    });
                    setErrorMessage("");
                } else if (newValue > 60) {
                    // If the entered value is greater than 60, set it to the maximum allowed value (60)
                    setErrorMessage('The max value allowed is 60');

                }
            }
        }
        if (field === 'extension_time') {
            const enteredValue = e.target.value.trim();
            const newValue = parseInt(enteredValue);
            if (!isNaN(newValue)) {
                // Check if the entered value is within the range 1 to 60
                if (newValue >= 1 && newValue <= 1440) {
                    // If it is within the range, update the state with the new value
                    setAuctionData({
                        ...auctionData,
                        [field]: newValue
                    });
                    setErrorMessages("");
                } else if (newValue > 1440) {
                    // If the entered value is greater than 60, set it to the maximum allowed value (60)
                    setErrorMessages('The max value allowed is 1440');

                }
            }
        }
        const updatedData = {
            ...auctionData,
            [field]: digitsOnly,
        };
        setAuctionData(updatedData)
        setEditedAuctionData((prevData) => ({ ...prevData, [field]: digitsOnly }));

        if (field === 'percentage') {
            setAuctionData((prevData) => ({ ...prevData, fees: '' }));
            setEditedAuctionData((prevData) => ({ ...prevData, fees: '' }));
        }
        if (field === 'fees') {
            setAuctionData((prevData) => ({ ...prevData, percentage: '' }));
            setEditedAuctionData((prevData) => ({ ...prevData, percentage: '' }));
        }
    }

    const handleVoluntaryContributionChange = (index, field, rawValue) => {
        if (field === 'value') {
            setLastEditedVoluntaryIndex(index);
        }

        const normalizeOptionValue = (value) => (value === null || value === undefined ? '' : String(value));

        if (field === 'is_recommended') {
            const currentOptions = auctionData?.buyer_fee_details?.percentage_options || [];
            const targetValue = normalizeOptionValue(currentOptions[index]?.value);
            if (targetValue.trim() === '') {
                return;
            }
        }

        const buildBuyerFeeDetails = (currentBuyerFeeDetails = {}) => {
            const existingOptions = Array.isArray(currentBuyerFeeDetails?.percentage_options)
                ? currentBuyerFeeDetails.percentage_options
                : [];

            const percentageOptions = [0, 1, 2].map((optionIndex) => ({
                value: normalizeOptionValue(existingOptions?.[optionIndex]?.value),
                is_recommended: !!existingOptions?.[optionIndex]?.is_recommended,
            }));

            if (field === 'value') {
                let digitsOnly = String(rawValue || '').replace(/\D/g, '');
                if (digitsOnly !== '' && !isNaN(digitsOnly)) {
                    const parsedValue = parseInt(digitsOnly, 10);
                    if (!isNaN(parsedValue)) {
                        const clampedValue = Math.min(100, parsedValue);
                        digitsOnly = clampedValue < 1 ? '' : clampedValue.toString();
                    }
                }

                percentageOptions[index] = {
                    ...(percentageOptions[index] || {}),
                    value: digitsOnly,
                };
            }

            if (field === 'is_recommended') {
                percentageOptions.forEach((option, optionIndex) => {
                    percentageOptions[optionIndex] = {
                        ...(option || {}),
                        is_recommended: optionIndex === index,
                    };
                });
            }

            return {
                ...(currentBuyerFeeDetails || {}),
                fee_type: 'voluntary_contribution',
                percentage_options: percentageOptions,
            };
        };

        const getRecommendedPercentage = (buyerFeeDetails) => {
            const recommendedOption = buyerFeeDetails?.percentage_options?.find((option) => option.is_recommended);
            return recommendedOption?.value || '';
        };

        const updatedDetails = buildBuyerFeeDetails(auctionData?.buyer_fee_details);

        setAuctionData((prevData) => ({
            ...prevData,
            buyer_fee_details: updatedDetails,
            percentage: getRecommendedPercentage(updatedDetails),
        }));

        setEditedAuctionData((prevData) => ({
            ...prevData,
            buyer_fee_details: updatedDetails,
            percentage: getRecommendedPercentage(updatedDetails),
        }));
    }

    const content = (<div>
        {showFullContent ? (
            <div>
                <p className='text-left' >Choose between three ways to end your auction:
                    <ul className="list-disc pl-4 mt-2 text-left">
                        <li><b>All Lots</b>: All lots close at the same set time.
                            As bidding is extended on all lots, underbidders can bid again on any lot in the auction
                            so this style of closing is useful for auctions where bidders may be interested in more than one lot.
                        </li>
                        <li className='mt-2' >
                            <b>Cascade</b>: Each lot closes at pre-set intervals only after the previous lot has closed.
                            If a bid is made during the last minute of a lot closing, the auction for that lot will extend.
                            Since lots close consecutively, a bidding extension will delay the closing of the next lot,
                            ensuring only one lot closes at a time.
                        </li>
                        <li className='mt-2'>
                            <b>Individual</b>: Each lot closes at a specified closing time, two minutes apart. A bid placed within the last
                            minute of a lot closing will only extend the bidding on that lot. The added time will not affect
                            the closing time of any other lots, so the lots may close out of numerical order. This style of
                            closing is ideal for large auctions with over 100 lots as bidding extensions apply only to lots
                            with active bidders.
                        </li>
                    </ul>
                </p>
                <button className='text-center underline mt-1'
                    onClick={() => setShowFullContent(false)} >Show Less</button>
            </div>
        ) : (
            <div>
                <p>
                    Choose between three ways to end your auction:
                    <ul className="list-disc pl-4 mt-2 text-left">
                        <li><b>All Lots</b>: All lots close at the same set time...</li>
                    </ul>
                </p>
                <button className='underline mt-1' onClick={() => setShowFullContent(true)}>Show More</button>
            </div>
        )}
    </div>
    );
    /**
     * Function to return the disabled state 
     * from disabled fields maping based on it's
     * auction status
     * @param {*} field 
     * @returns 
     */
    const returnDisableState = (field) => {
        let statusCheck = false;
        let status = auctionData?.status ? auctionData.status : "";
        if (status)
            status = status !== "Accepting bids" ? status.toLowerCase() : "acceptingBids"
        switch (field) {
        case "extension_time_between_lots": {
            statusCheck = disableFieldsBasedOnAuctionStatus[status]?.extension_time_between_lots;
            break;
        }
        case "extension_time": {
            statusCheck = disableFieldsBasedOnAuctionStatus[status]?.extension_time;
            break;
        }
        case "extension_type": {
            statusCheck = disableFieldsBasedOnAuctionStatus[status]?.extension_type;
            break;
        }
        case "registration_type": {
            statusCheck = disableFieldsBasedOnAuctionStatus[status]?.registration_type;
            break;
        }
        case "add_buyer_fees": {
            statusCheck = disableFieldsBasedOnAuctionStatus[status]?.add_buyer_fees;
            break;
        }
        default:
            break;
        }
        return statusCheck;
    }


    useEffect(() => {
        if (!plan_status || !ldClient) return;

        const email = localStorage.getItem('user') || 'anonymous';
        const context = {
            kind: 'user',
            key: email,
            email: email,
            plan: plan_status,
        };

        const readFlags = () => {
            setIsManual(ldClient.variation('manual-approval', false));
            setIsCardValid(ldClient.variation('CreditCardValidation', false));
            setRegisterWithCreditCardEnabled(ldClient.variationDetail('RegisterWithCreditCard', false).value);
        };

        ldClient.identify(context).then(readFlags);
        ldClient.on('change', readFlags);

        return () => ldClient.off('change', readFlags);
    }, [plan_status, ldClient]);

    useEffect(() => {
        if (!isBuyerFeeType(auctionData?.add_buyer_fees, 'voluntary')) {
            return;
        }

        const existingOptions = Array.isArray(auctionData?.buyer_fee_details?.percentage_options)
            ? auctionData.buyer_fee_details.percentage_options
            : [];

        const normalizedOptions = [0, 1, 2].map((optionIndex) => ({
            value: existingOptions?.[optionIndex]?.value || '',
            is_recommended: !!existingOptions?.[optionIndex]?.is_recommended,
        }));

        const hasAnyValue = normalizedOptions.some((option) => option.value !== '');
        const hasRecommended = normalizedOptions.some((option) => option.is_recommended);

        if (hasAnyValue || hasRecommended) {
            return;
        }

        const defaultOptions = normalizedOptions.map((option, optionIndex) => ({
            ...option,
            is_recommended: optionIndex === 0,
        }));

        setAuctionData((prevData) => ({
            ...prevData,
            buyer_fee_details: {
                ...(prevData?.buyer_fee_details || {}),
                fee_type: 'voluntary_contribution',
                percentage_options: defaultOptions,
            },
            percentage: defaultOptions[0]?.value || '',
        }));

        setEditedAuctionData((prevData) => ({
            ...prevData,
            buyer_fee_details: {
                ...(prevData?.buyer_fee_details || {}),
                fee_type: 'voluntary_contribution',
                percentage_options: defaultOptions,
            },
            percentage: defaultOptions[0]?.value || '',
        }));
    }, [auctionData?.add_buyer_fees, auctionData?.buyer_fee_details?.percentage_options, setAuctionData, setEditedAuctionData]);

    return (
        <div className="auction-rule-content">
            {/* <!-- dropdown for extension type--> */}
            <Listbox as="div" disabled={returnDisableState("extension_type")}
                className="relative w-full" value={auctionData.extension_type}
                onChange={(value) => {
                    setExtensionTypeShow(true)
                    setAuctionData(prevData => ({ ...prevData, extension_type: value.name }))
                    setEditedAuctionData(prevData => ({ ...prevData, extension_type: value.name }))
                    if (value.name == "All Lots") {
                        setAuctionData((prevData) => ({ ...prevData, extension_time_between_lots: '' }));
                        setEditedAuctionData((prevData) => ({ ...prevData, extension_time_between_lots: '' }));
                    }
                }}>
                <div className="flex mt-4 items-center gap-2">
                    <p className="text-[12px] font-medium leading-normal text-[#343434]">Extension type</p>
                    <Tooltip
                        html={content}
                        position="left"
                        trigger="click"
                        interactive={true}
                        popperOptions={{
                            modifiers: {
                                preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'window',
                                },
                                flip: {
                                    enabled: true,
                                    behavior: ['top', 'bottom', 'right', 'left'],
                                },
                            },
                        }}
                        arrow="true"
                        arrowSize="regular"
                    >
                        <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                    </Tooltip>
                </div>
                <Listbox.Button data-testid='extension-type' type="button"
                    className={`text-[14px] text-start relative w-full h-11 px-3 border 
                    disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                border-[#A1A1A9] ${extensionTypeShow ? 'text-[#343434]' : 'text-[#A1A1A9]'} 
                outline-none font-medium leading-normal`}
                    id="extension-type"
                    data-te-dropdown-toggle-ref
                    aria-expanded="false"
                    data-te-ripple-init
                    data-te-ripple-color="light">
                    <ToolTip content={auctionData.extension_type === '' ? 'Select' : auctionData.extension_type}>
                        <span className="truncate block pr-6">
                            {auctionData.extension_type === '' ? 'Select' : auctionData.extension_type}
                        </span>
                    </ToolTip>
                </Listbox.Button>
                <img src="/images/dropdown-icon.png" alt="dropdown-icon" className="absolute top-[40px] right-[15px]"
                    loading="lazy" />
                <Listbox.Options
                    className="bg-white rounded-[8px] z-30  absolute w-full [&[data-te-dropdown-show]]:block 
                shadow-bs1 list-none" aria-labelledby="extension-type">
                    <Transition
                        as={Fragment}
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'>
                        <div className="pr-[15px] py-2 max-h-[150px] customScrollbar 
                                overflow-y-auto overflow-x-hidden ">
                            {extenstionType.map((extentionType, index) => (
                                <Listbox.Option key={extentionType.id} value={extentionType}
                                    disabled={(auctionData.template_name === "Single Lot" || auctionData.template_name === "Single lot") ?
                                        (extentionType.name !== 'Individual Lots' && extentionType.name !== 'Individual lots') :
                                        ((pricing.free_user === true || pricing?.plan_type?.includes('Free') ||
                                            pricing?.plan_type?.includes('Starter')) &&
                                            extentionType.name !== 'All Lots')}
                                    as="div"
                                    className="pl-2 py-1 list-none
                                        text-[12px] leading-normal font-medium text-[#343434]">
                                    {({ active, selected, disabled }) => (
                                        <li className={`py-1 -mt-0.5 rounded-[11px] px-2.5 ${!disabled && active ? 'bg-[#E6E6E6] cursor-pointer' :
                                            `bg-white ${disabled ? 'text-[#A1A1A9] cursor-auto' :
                                                'text-[#343434] cursor-pointer'}`
                                        }`} data-testid={`extension-type-${index}`}>
                                            <ToolTip content={extentionType.name}>
                                                <span className="truncate block">
                                                    {extentionType.name}
                                                </span>
                                            </ToolTip>
                                        </li>
                                    )}
                                </Listbox.Option>
                            ))}
                        </div>
                    </Transition>
                </Listbox.Options>
            </Listbox>
            {/* <!-- time between lots --> */}
            {(auctionData.extension_type === 'Cascade' || auctionData.extension_type === 'Individual Lots') && auctionData.template_name !== "Single Lot" &&
                <div className="pt-3">
                    <div className="flex items-center gap-2">
                        <p className="font-medium text-[#343434] text-[12px] leading-normal">Time between lots (mins) </p>
                        <ToolTip trigger="click"
                            content="Choose how long you would like to extend the auction by if someone bids 
                        in the last minute of the auction">
                            <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                        </ToolTip>
                    </div>
                    <input type="text" autoComplete='off' id="extension_time_between_lots"
                        disabled={returnDisableState("extension_time_between_lots")}
                        className="border border-[#A1A1A9] w-full px-3 py-3 outline-none text-[14px] 
                        disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]"
                        value={auctionData.extension_time_between_lots}
                        onChange={(e) => handleBuyerFeeValueChange(e, 'extension_time_between_lots')}
                        placeholder="2" />
                    {errorMessage && <p className="text-[10px] pt-1.5 font-medium leading-normal enddate-errormsg 
                text-[#984848]">{errorMessage}</p>}

                </div>
            }
            <div className="pt-3">
                <div className="flex gap-2">
                    <p className="font-medium text-[#343434] text-[12px] leading-normal">Extension time (mins)</p>
                    <ToolTip trigger="click items-center"
                        content="Choose how long you would like to extend the auction by if someone bids 
                        in the last minute of the auction">
                        <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                    </ToolTip>
                </div>
                <input id='extension-time' autoComplete='off' type="text" value={auctionData.extension_time}
                    disabled={returnDisableState("extension_time")}
                    onChange={(e) => handleBuyerFeeValueChange(e, 'extension_time')}
                    className="border border-[#A1A1A9] w-full px-3 py-3 outline-none text-[14px] 
                    disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]" placeholder="2" />

                {errorMessages && <p className="text-[10px] pt-1.5 font-medium leading-normal enddate-errormsg 
                text-[#984848]">{errorMessages}</p>}
            </div>
            {/* <!-- dropdown for registration type--> */}
            <Listbox as="div" className="relative w-full"
                disabled={returnDisableState("registration_type")}
                value={auctionData.registration_type}
                onChange={(value) => {
                    setRegistrationTypeShow(true)
                    setAuctionData(prevData => ({ ...prevData, registration_type: value.name }))
                    setEditedAuctionData(prevData => ({ ...prevData, registration_type: value.name }))
                }}>
                {({ open }) => (
                    <>
                        <div className="flex mt-4 items-center gap-2">
                            <p className="text-[12px] font-medium leading-normal text-[#343434]">Registration type</p>
                            <ToolTip trigger="click"
                                content="Choose your bidder registration requirements. Bidders can register with just their email, 
                        you can require a bank card or manually approve each one.">
                                <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                            </ToolTip>
                        </div>
                        <Listbox.Button type="button"
                            className={`text-[14px] text-start relative w-full h-11 px-3 border 
                            disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                            border-[#A1A1A9] ${registrationTypeShow ? 'text-[#343434]' : 'text-[#A1A1A9]'} 
                            outline-none font-medium leading-normal`} id="registration-type">
                            <ToolTip content={auctionData.registration_type === '' ? 'Select' : auctionData.registration_type}>
                                <span className="truncate block pr-6">
                                    {auctionData.registration_type === '' ? 'Select' : auctionData.registration_type}
                                </span>
                            </ToolTip>
                        </Listbox.Button>
                        <img src="/images/dropdown-icon.png" alt="dropdown-icon" className="absolute top-[40px] right-[15px]"
                            loading="lazy" />
                        <Listbox.Options
                            className="bg-white rounded-[8px] z-30 absolute w-full [&[data-te-dropdown-show]]:block 
                shadow-bs1 list-none" aria-labelledby="extension-type">
                            <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="pr-[15px] py-2 max-h-[150px] customScrollbar overflow-y-auto overflow-x-hidden">
                                    {registrationType.map((registrationType) => {
                                        if (!registerWithCreditCardEnabled && registrationType.name === 'Register with credit card') {
                                            return null;
                                        }
                                        const isStripeRequired = registrationType.name === 'Register with credit card' && profile.stripe_status !== 'connected';
                                        const isVoluntaryConflict = registrationType.name === 'Register with credit card' &&
                                            isBuyerFeeType(auctionData.add_buyer_fees, 'voluntary');
                                        const isDisabled = ((pricing.free_user===true || pricing.plan_type==='Free' ||
                                            pricing.plan_type==='Starter' || (isCardValid && registrationType.name =='Credit (bank) card validation')
                                                || (isManual && registrationType.name =='Manual approval') || isStripeRequired) &&
                                            (registrationType.name !== 'Email only')) || isVoluntaryConflict;
                                        return (
                                            <ToolTip
                                                key={registrationType.id}
                                                content={isStripeRequired
                                                    ? "You must connect to Stripe to use this feature"
                                                    : "Voluntary contribution cannot be selected for 'Register with Credit Card'."}
                                                position="top"
                                                trigger="mouseenter"
                                                disabled={!isStripeRequired && !isVoluntaryConflict}
                                            >
                                                <Listbox.Option value={registrationType}
                                                    disabled={isDisabled}
                                                    as="div" className="pl-2 py-1 text-[12px]
                                                    leading-normal font-medium text-[#A1A1A9] list-none">
                                                    {({ active, selected,disabled }) => (
                                                        <li className={`py-1 -mt-0.5 rounded-[11px] px-2.5
                                                        ${!disabled && active ? 'bg-[#E6E6E6] cursor-pointer' :
                                                            `${disabled?'text-[#A1A1A9] cursor-auto bg-white':
                                                                'text-[#343434] cursor-pointer bg-white'}`
                                                        }`}>
                                                            {registrationType.name}
                                                        </li>
                                                    )}
                                                </Listbox.Option>
                                            </ToolTip>
                                        );
                                    })}
                                </div>
                            </Transition>
                        </Listbox.Options>
                    </>
                )}
            </Listbox>
            {/* <!-- dropdown for add buyer type--> */}
            <Listbox as="div"
                disabled={returnDisableState("add_buyer_fees")}
                className="relative w-full" value={auctionData.add_buyer_fees}
                onChange={(value) => {
                    setAuctionData((prevData) => {
                        const isSwitchingFromVoluntary = isBuyerFeeType(prevData?.add_buyer_fees, 'voluntary') &&
                            !isBuyerFeeType(value.key, 'voluntary');

                        return {
                            ...prevData,
                            add_buyer_fees: value.key,
                            ...(isSwitchingFromVoluntary ? { buyer_fee_details: {} } : {}),
                        };
                    });

                    setEditedAuctionData((prevData) => {
                        const isSwitchingFromVoluntary = isBuyerFeeType(prevData?.add_buyer_fees, 'voluntary') &&
                            !isBuyerFeeType(value.key, 'voluntary');

                        return {
                            ...prevData,
                            add_buyer_fees: value.key,
                            ...(isSwitchingFromVoluntary ? { buyer_fee_details: {} } : {}),
                        };
                    });
                }}>
                <div className="flex mt-4 items-center gap-2">
                    <p className="text-[12px] font-medium leading-normal text-[#343434]">Add buyer fees</p>
                    <ToolTip trigger="click"
                        content="You can add additional fees to the buyer either as a percentage of the 
                        winning bid price or as a flat fee.">
                        <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                    </ToolTip>
                </div>
                <Listbox.Button type="button"
                    className={`text-[14px] text-start relative w-full h-11 px-3 border 
                    disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                    border-[#A1A1A9] ${auctionData.add_buyer_fees === '' ? 'text-[#A1A1A9]' : 'text-[#343434]'} 
                    outline-none font-medium leading-normal`} id="add_buyer_fee" data-testid="add_buyer_fee"
                    aria-expanded="false"
                    data-te-ripple-init
                    data-te-ripple-color="light">
                    <ToolTip content={auctionData.add_buyer_fees === '' ? 'Select' : buyerFeeLabel(auctionData.add_buyer_fees)}>
                        <span className="truncate block pr-6">
                            {auctionData.add_buyer_fees === '' ? 'Select' : buyerFeeLabel(auctionData.add_buyer_fees)}
                        </span>
                    </ToolTip>
                </Listbox.Button>
                <img src="/images/dropdown-icon.png" alt="dropdown-icon" className="absolute top-[40px] right-[15px]"
                    loading="lazy" />
                <Listbox.Options
                    className="bg-white rounded-[8px] z-30  absolute w-full [&[data-te-dropdown-show]]:block 
                shadow-bs1 list-none" aria-labelledby="add_buyer_fee"
                    data-te-dropdown-menu-ref>
                    <Transition
                        as={Fragment}
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'>
                        <div className="pr-[15px] py-2 max-h-[150px] customScrollbar overflow-y-auto overflow-x-hidden">
                            {buyerFees.map((fees, index) => {
                                if (fees.key === 'voluntary' && auctionData.registration_type === 'Register with credit card') {
                                    return null;
                                }
                                return (
                                    <Listbox.Option key={fees.id} value={fees}
                                        disabled={(pricing.free_user === true || pricing.plan_type === 'Free') &&
                                            (fees.name !== 'No additional fees (default)')}
                                        as="div"
                                        className="pl-2 list-none py-1
                                            text-[12px] leading-normal font-medium text-[#4A4A4A]">
                                        {({ active, selected, disabled }) => (
                                            <li className={`py-1 -mt-0.5 rounded-[11px] px-2.5
                                            ${!disabled && active ? 'bg-[#E6E6E6] cursor-pointer' :
                                                `${disabled ? 'text-[#A1A1A9] cursor-auto bg-white' :
                                                    'text-[#343434] cursor-pointer bg-white'}`
                                            }`}>
                                                <ToolTip content={`${fees.name}${fees.default ? ' (default)' : ''}`}>
                                                    <span className="truncate block">
                                                        {fees.name} {fees.default ? '(default)' : ''}
                                                    </span>
                                                </ToolTip>
                                            </li>
                                        )}
                                    </Listbox.Option>
                                );
                            })}
                        </div>
                    </Transition>
                </Listbox.Options>
            </Listbox>
            {/* <!-- percentage --> */}
            {isBuyerFeeType(auctionData.add_buyer_fees, 'percentage') &&
                <div className="pt-3">
                    <div className="flex items-center gap-2">
                        <p className="font-medium text-[#343434] text-[12px] leading-normal">Percentage</p>
                        <ToolTip trigger="click"
                            content="You can add additional fees to the buyer either as a percentage of the 
                            winning bid price or as a flat fee.">
                            <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                        </ToolTip>
                    </div>
                    <input autoComplete='off' id="percentage-value" type="text"
                        disabled={auctionData.status == "Published" || auctionData.status == "Accepting bids"}
                        className="border border-[#A1A1A9] w-full px-3 py-3 outline-none 
                        disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                text-[14px] leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]"
                        value={auctionData.percentage === NaN ? '' : auctionData.percentage}
                        onChange={(e) => handleBuyerFeeValueChange(e, 'percentage')}
                        placeholder="%" />
                </div>
            }
            {/* <!-- fees --> */}
            {isBuyerFeeType(auctionData.add_buyer_fees, 'fixed') &&
                <div className="pt-3">
                    <div className="flex items-center gap-2">
                        <p className="font-medium text-[#343434] text-[12px] leading-normal">Fees</p>
                        <ToolTip trigger="click"
                            content="You can add additional fees to the buyer either as a percentage of the 
                        winning bid price or as a flat fee.">
                            <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                        </ToolTip>
                    </div>
                    <input autoComplete='off' id="fees" type="text"
                        disabled={auctionData.status == "Published" || auctionData.status == "Accepting bids"}
                        className="border border-[#A1A1A9] w-full px-3 py-3 outline-none text-[14px] 
                    disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]"
                        value={auctionData.fees} onChange={(e) => handleBuyerFeeValueChange(e, 'fees')}
                        placeholder={currencySymbolMapping[auctionData.currency] || 'N/A'} />
                </div>}
            {/* <!-- voluntary contribution --> */}
            {isBuyerFeeType(auctionData.add_buyer_fees, 'voluntary') && (
                <div className="pt-3">
                    <p className="text-[#717179] text-[12px] leading-normal font-medium mb-4" data-testid="voluntary-contribution-tooltip">
                        Add up to 3 percentage fees to present to your buyers at checkout, and select the one you want to display as the recommended option.
                    </p>
                    <div className="flex justify-end mb-2">
                        <p className="text-[#717179] text-[10px] font-medium leading-normal mr-2">Recommended</p>
                    </div>
                    {[0, 1, 2].map((index) => {
                        const isBuyerFeeDisabled = returnDisableState("add_buyer_fees");
                        const val = auctionData?.buyer_fee_details?.percentage_options?.[index]?.value || '';
                        const isRecommended = !!auctionData?.buyer_fee_details?.percentage_options?.[index]?.is_recommended;
                        const isDuplicate = val !== '' && auctionData?.buyer_fee_details?.percentage_options?.some((opt, i) => i !== index && opt.value !== '' && opt.value === val);
                        const isDuplicateForEditedField = isDuplicate && lastEditedVoluntaryIndex === index;
                        const isError = (val === '' && isRecommended) || isDuplicateForEditedField;

                        return (
                            <div key={index} className="bg-[#F4F4F5] p-2.5 rounded-[8px] flex items-center gap-4 mb-3">
                                <div className="flex-1">
                                    <div className="relative">
                                        <span className="absolute pointer-events-none left-3 top-1/2 -translate-y-1/2 text-[#A1A1A9] text-[14px] font-medium">%</span>
                                        <input
                                            type="text"
                                            autoComplete='off'
                                            disabled={isBuyerFeeDisabled}
                                            data-testid={`voluntary-contribution-${index}`}
                                            className={`${isRecommended ? 'border-2' : 'border'} ${isError ? 'border-[#984848]' : 'border-[#282828]'} bg-white rounded-[4px] w-full pl-8 pr-3 py-2.5 outline-none text-[14px] leading-normal font-medium text-[#343434] placeholder:text-[#A1A1A9]`}
                                            value={val}
                                            onChange={(e) => handleVoluntaryContributionChange(index, 'value', e.target.value)}
                                        />
                                    </div>
                                    {isDuplicateForEditedField && (
                                        <p className="text-[10px] pt-1.5 font-medium leading-normal text-[#984848]">
                                            Please enter a different percentage value to the one you have already entered
                                        </p>
                                    )}
                                </div>
                                <div className="flex justify-center items-center pr-2">
                                    <input
                                        id={`recommended-fee-${recommendedFeeGroupName}-${index}`}
                                        type="radio"
                                        data-testid={`recommended-fee-${index}`}
                                        name={`recommended-fee-${recommendedFeeGroupName}`}
                                        className="w-6 h-6 accent-[#282828] cursor-pointer"
                                        disabled={isBuyerFeeDisabled}
                                        checked={isRecommended}
                                        onChange={() => handleVoluntaryContributionChange(index, 'is_recommended', true)}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )
}
